import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import { SessionService } from '@parantion/components'
import packageJson from '../../package.json'
import groups from './groups-module'
import base from './base-module'
import importModule from './import-module'
import jobsModule from './jobs-module'

Vue.use(Vuex)

const service = SessionService.getInstance(packageJson.name)
service.setSession()
const localForage = service.localForage
const sessionKey = service.sessionKey

const vuexAsync = new VuexPersistence({
  key: sessionKey,
  saveState: (key, state) => {
    return localForage.setItem(key, state)
  },
  restoreState: (key) => {
    return localForage.getItem(key)
  },
  asyncStorage: true
})

const vuexLocal = new VuexPersistence({
  key: sessionKey,
  storage: window.sessionStorage,
  reducer: (state) => ({
    parantion: {
      baseUrl: state.parantion.baseUrl,
      database: state.parantion.database,
      subdomains: state.parantion.subdomains,
      domain: state.parantion.domain,
      environment: state.parantion.environment,
      useLockScreen: state.parantion.useLockScreen,
      autoLockscreen: state.parantion.autoLockscreen,
      lockoutTime: state.parantion.lockoutTime,
      warningTime: state.parantion.warningTime,
      user: state.parantion.user,
      rights: {
        access_link_available: '0'
      }
    }
  })
})

const store = new Vuex.Store({
  plugins: [vuexAsync.plugin, vuexLocal.plugin],
  modules: {
    groups,
    base,
    import: importModule,
    jobs: jobsModule
  }
})

export default store
